import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { COUNTRY_CODE } from 'src/app/consts/country-code.const';
import { Call } from 'src/app/models/call.model';
import { DiagnosisService } from 'src/app/services/diagnosis.service';
import { SharedDataService } from 'src/app/services/shared-data.service';

@Component({
  selector: 'app-call-information',
  templateUrl: './call-information.component.html',
  styleUrls: ['./call-information.component.css'],
  standalone: false
})
export class CallInformationComponent implements OnInit {
  @Input() call!: Call;

  @Input() medicalHistory?: string;

  patientBirthDate?: Date | null;
  diagnosis: string | undefined;
  isBrazil = false;

  constructor(
    private diagnosisService: DiagnosisService,
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit(): void {
    this.initializeVariables();

    this.sharedDataService.diagnosisComplete$.pipe(debounceTime(0)).subscribe(() => {
      this.initializeVariables();
    });
  }

  initializeVariables(): void {
    const dateObject =
      this.call?.patient?.birthDate || this.call?.patient?.birthDate === 0 ? moment.unix(this.call.patient.birthDate).utc().toDate() : null;
    this.patientBirthDate = dateObject ? new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate()) : null;

    if (this.call?.diagnosis?.diagnosis) this.diagnosis = this.diagnosisService.getByCode(this.call?.diagnosis?.diagnosis);
    this.isBrazil = this.call?.provider?.country?.countryCode === COUNTRY_CODE.BRAZIL;
    console.log('initializeVariables: received', this.call?.patient?.birthDate, ' and converted to ', this.patientBirthDate);
  }

  get googleMapsUrl(): string {
    if (!this.call?.coordinates?.latitude || !this.call?.coordinates?.longitude) return '';

    return `https://maps.google.com/?q=${this.call.coordinates.latitude},${this.call.coordinates.longitude}`;
  }
}
